// @flow
import React from 'react';
import PropTypes from 'prop-types';

import './SizeLabel.scss';

/**
 * Small product label that sits on top of the tile. Has little shadow effect
 */

const SizeLabelComponent = (props: { label: true }) => (
  <span className="size-label-component u-fontFamily-primaryMedium">{props.label}</span>
);

SizeLabelComponent.displayName = 'SizeLabel';

SizeLabelComponent.propTypes = {
  label: PropTypes.string.isRequired,
};

export default SizeLabelComponent;
